import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormOperator } from 'system/view-models/operator-list';
import PmiTextField from 'shell/components/shared/text-field';
import ServiceCodeAutoComplete from './service-code-list';

interface FiltersOperatorProps {
  filtersOperatorForm: FormikProps<FiltersFormOperator>;
}

const FiltersOperator = ({ filtersOperatorForm }: FiltersOperatorProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-operators-content"
        id="panel-operators-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filtersOperatorForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8} container spacing={2}>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Codice operatore"
                  label="Codice"
                  id="code"
                  name="code"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={filtersOperatorForm.values.code}
                  onChange={filtersOperatorForm.handleChange}
                  error={
                    filtersOperatorForm.touched.code && Boolean(filtersOperatorForm.errors.code)
                  }
                  helperText={filtersOperatorForm.errors.code}
                  inputProps={{
                    maxLength: '6',
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Codana"
                  label="CODANA"
                  id="codana"
                  name="codana"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={filtersOperatorForm.values.codana || ''}
                  onChange={filtersOperatorForm.handleChange}
                  error={
                    filtersOperatorForm.touched.codana && Boolean(filtersOperatorForm.errors.codana)
                  }
                  helperText={filtersOperatorForm.errors.codana}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <PmiTextField
                  aria-label="Codice fiscale"
                  label="Codice fiscale"
                  id="fiscalCode"
                  name="fiscalCode"
                  fullWidth
                  type="text"
                  variant="outlined"
                  value={filtersOperatorForm.values.fiscalCode || ''}
                  onChange={filtersOperatorForm.handleChange}
                  error={
                    filtersOperatorForm.touched.fiscalCode &&
                    Boolean(filtersOperatorForm.errors.fiscalCode)
                  }
                  helperText={filtersOperatorForm.errors.fiscalCode}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              <PmiTextField
                aria-label="Nome operatore"
                label="Nome"
                id="name"
                name="name"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersOperatorForm.values.name}
                onChange={filtersOperatorForm.handleChange}
                error={filtersOperatorForm.touched.name && Boolean(filtersOperatorForm.errors.name)}
                helperText={filtersOperatorForm.errors.name}
                inputProps={{
                  maxLength: '100',
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Qualifica operatore"
                label="Qualifica"
                id="qualification"
                name="qualification"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersOperatorForm.values.qualification}
                onChange={filtersOperatorForm.handleChange}
                error={
                  filtersOperatorForm.touched.qualification &&
                  Boolean(filtersOperatorForm.errors.qualification)
                }
                helperText={filtersOperatorForm.errors.qualification}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ServiceCodeAutoComplete
                aria-label="Codice Servizio operatore"
                label="Codice Servizio"
                id="serviceCode"
                selectedValue={filtersOperatorForm.values.serviceCode}
                handleChange={(value) => filtersOperatorForm.setFieldValue('serviceCode', value)}
                error={
                  filtersOperatorForm.touched.serviceCode &&
                  Boolean(filtersOperatorForm.errors.serviceCode)
                }
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Servizio operatore"
                label="Servizio"
                id="service"
                name="service"
                fullWidth
                type="text"
                variant="outlined"
                value={filtersOperatorForm.values.service}
                onChange={filtersOperatorForm.handleChange}
                error={
                  filtersOperatorForm.touched.service && Boolean(filtersOperatorForm.errors.service)
                }
                helperText={filtersOperatorForm.errors.service}
              />
            </Grid>
            <Grid item xs display="flex" justifyContent="flex-end">
              <PmiButton
                variant="contained"
                type="submit"
                color="secondary"
                disabled={!filtersOperatorForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersOperator.displayName = 'Filters Operator component';

export default FiltersOperator;
